import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data-service.service';

@Component({
  selector: 'tournament-info',
  templateUrl: './tournament-info.component.html',
  styleUrls: ['./tournament-info.component.scss']
})
export class TournamentInfoComponent implements OnInit {
  public summaries: BracketSummary[] = [];

  constructor(public ds: DataService) { }

  ngOnInit(): void { 
    this.summaries = [];
    this.ds.currentTournament.brackets.forEach(b => {
      if (b.level > 0) {
        let summary = new BracketSummary();
        summary.name = b.bracketName;

        let round = b.rounds && b.rounds.length > 0 ? b.rounds[b.rounds.length - 1] : null;
        if (round) {
          let finished = false;
          round.matches.forEach(m => {
            if (m.roundRank === 1 || m.roundRank === 2) {
              if (m.complete) {
                finished = true;
                if (m.teams[0].score > m.teams[1].score) {
                  if (m.roundRank === 1) {
                    summary.firstPlace = m.teams[0].name;
                    summary.secondPlace = m.teams[1].name;
                  } else {
                    summary.thirdPlace = m.teams[0].name;
                  }
                } else {
                  if (m.roundRank === 1) {
                    summary.firstPlace = m.teams[1].name;
                    summary.secondPlace = m.teams[0].name;
                  } else {
                    summary.thirdPlace = m.teams[1].name;
                  }
                }
              } else {
                finished = false;
              }
            }
          });
          
          if (finished) {
            this.summaries.push(summary);
          }
        } 
      }
    });
  }
}

class BracketSummary {
  name: string;
  firstPlace: string;
  secondPlace: string;
  thirdPlace: string;
}
